import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import { EnrolledInfo } from './StickyInfoCard';
import useCertificationCourseData from './useCertificationCourseData';

const Container = styled.div`
  width: 100%;
  ${mediaQuery.uptoMobile} {
    overflow: hidden;
    display: grid;
  }
`;

const Title = styled(Typography)``;

const Description = styled(Typography)`
  margin-top: ${Spacings.SPACING_4B};
  color: var(--color-text-primary);
`;

const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
  margin: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
`;

const StepWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_4B};
`;

const StepTitle = styled(Typography)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
    line-height: ${Spacings.SPACING_5B};
  }
`;

const StepDescription = styled(Typography)`
  margin-top: ${Spacings.SPACING_1B};
  margin-bottom: ${Spacings.SPACING_3B};
`;

const StepNumber = styled.div`
  width: 46px;
  height: 46px;
  min-width: 46px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 50%;
  background: var(--color-divider-secondary);
  ${mediaQuery.uptoMobile} {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
`;
const Number = styled(Typography)`
  color: var(--color-i-gray);
`;

const StepInfo = styled.div``;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    gap: ${Spacings.SPACING_4B};
  }
`;
const StyledButton = styled(Button)`
  padding: 12px 45px;
  width: 215px;
  height: 48px;
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H5};
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const Steps = ({ steps }) => {
  return (
    <StepsWrapper>
      {steps?.map((step, index) => {
        return (
          <StepWrapper key={step.uid}>
            <StepNumber>
              <Number variant="h4">{index + 1}</Number>
            </StepNumber>
            <StepInfo>
              <StepTitle variant="h5">{step.title}</StepTitle>
              <StepDescription variant="p2" color="var(--color-text-secondary)">
                {step.description}
              </StepDescription>
            </StepInfo>
          </StepWrapper>
        );
      })}
    </StepsWrapper>
  );
};

const ApplicationProcess = ({ goalUID, handleIInterestedCTA }) => {
  const { sections } = useCertificationCourseData(goalUID);
  const applicationProcess = sections?.applicationProcess ?? {};
  return (
    <Container>
      <Title variant="h3">{applicationProcess.applicationProcessTitle}</Title>
      <Description variant="p2" color="var(--color-text-secondary)">
        {applicationProcess.applicationProcessDescription}
      </Description>
      <Steps steps={applicationProcess.applicationSteps} />
      <ButtonWrapper>
        <StyledButton
          onClick={handleIInterestedCTA}
          size="large"
          variant="primary"
          label="I’m interested"
        />
        <EnrolledInfo goalUID={goalUID} width="296px" />
      </ButtonWrapper>
    </Container>
  );
};

export default ApplicationProcess;
